import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const SellersList = () => import(/* webpackChunkName: "sellers" */ '@/views/Sellers/List.vue');
const SellerCreate = () => import(/* webpackChunkName: "sellers" */ '@/views/Sellers/Create.vue');
const SellerShow = () => import(/* webpackChunkName: "sellers" */ '@/views/Sellers/Show.vue');
const SellerEdit = () => import(/* webpackChunkName: "sellers" */ '@/views/Sellers/Edit.vue');

const VisitCreate = () => import(/* webpackChunkName: "sellers-visits" */ '@/views/Visits/Create.vue');

const SellerOrderList = () => import(/* webpackChunkName: "sellers-orders" */ '@/views/Orders/SellerList.vue');

let sellersPages = {
  path: '/sellers',
  redirect: '/sellers',
  component: DashboardLayout,
  name: 'Sellers',
  meta: {
    title: 'Asesores Técnicos',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'SellersList',
      meta: {
        title: 'Listado',
        auth: ['sellers.index'],
      },
      component: SellersList,
    },
    {
      path: 'create',
      name: 'SellerCreate',
      meta: {
        title: 'Nuevo',
        auth: ['sellers.store'],
      },
      component: SellerCreate,
    },
    {
      path: ':id',
      name: 'SellerShow',
      meta: {
        title: 'Detalle',
        auth: ['sellers.show'],
      },
      component: SellerShow,
    },
    {
      path: ':id/edit',
      name: 'SellerEdit',
      meta: {
        title: 'Editar',
        auth: ['sellers.update'],
      },
      component: SellerEdit,
    },
    {
      path: ':id/visits/create',
      name: 'SellerCreateVisit',
      meta: {
        title: 'Nueva Visita',
        typeToShow: 'Seller',
        resource: 'sellers',
        auth: ['visits.store'],
      },
      component: VisitCreate,
    },
    {
      path: ':id/orders',
      name: 'SellerOrderList',
      meta: {
        title: 'Órdenes del distribuidor',
        entity: 'sellers',
        auth: ['orders.index'],
      },
      component: SellerOrderList,
    },
  ],
};

export default sellersPages;
